import { Mountain, Ruler, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useMeasurementStore } from "@/stores/measurementStore";

interface MeasurementPanelProps {
  onStartMeasurement: () => void;
}

export const MeasurementPanel = ({
  onStartMeasurement,
}: MeasurementPanelProps) => {
  const measurements = useMeasurementStore((state) => state.measurements);
  const pendingFirstPoint = useMeasurementStore(
    (state) => state.pendingFirstPoint,
  );
  const setMeasurementType = useMeasurementStore(
    (state) => state.setMeasurementType,
  );
  const startMeasurementSession = useMeasurementStore(
    (state) => state.startMeasurementSession,
  );
  const clearAllMeasurements = useMeasurementStore(
    (state) => state.clearAllMeasurements,
  );

  const canClearMeasurements =
    measurements.length > 0 || pendingFirstPoint !== null;

  const handleStartMeasurement = (
    mode: "distance-ground" | "height-from-ground",
  ) => {
    setMeasurementType(mode);
    startMeasurementSession();
    onStartMeasurement();
  };

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <p className="text-xs text-slate-600">
          Lance une mesure en 2 clics. Après le premier point, la
          prévisualisation suit votre curseur.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <Button
          type="button"
          variant="outline"
          className="justify-start"
          onClick={() => handleStartMeasurement("distance-ground")}
        >
          <Ruler className="h-4 w-4" />
          Distance au sol
        </Button>
        <Button
          type="button"
          variant="outline"
          className="justify-start"
          onClick={() => handleStartMeasurement("height-from-ground")}
        >
          <Mountain className="h-4 w-4" />
          Hauteur
        </Button>
      </div>

      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          variant="destructive"
          onClick={clearAllMeasurements}
          disabled={!canClearMeasurements}
        >
          <Trash2 className="h-4 w-4" />
          Supprimer toutes les mesures
        </Button>
      </div>

      <p className="text-xs text-slate-500">
        Choisissez Distance au sol ou Hauteur pour démarrer une mesure. Les
        mesures sont stockées localement puis supprimées au rechargement de la
        page.
      </p>
    </div>
  );
};
